<template>
    <div v-if="Object.keys(mutableSelection).length > 0">
        <div class="flex flex-col gap-2">
            <div class="flex flex-wrap gap-2 justify-between">
                <checkbox v-model="mutableSelection.copy_from_portfolios" @input="togglePortfolioList()" label="Only specific portfolios"
                          label-styling="font-medium">
                </checkbox>

                <div class="flex flex-wrap items-center gap-6">
                    <button v-if="mutableSelection.copy_from_portfolios && mutableSelection.section === 'inspections'"
                            @click.prevent="selectSameAsAssetPortfolios()"
                            class="bg-gray-100 hover:bg-gray-200 transition duration-300 rounded-md p-1">
                        Set Same as Assets Section
                    </button>

                    <checkbox v-if="mutableSelection.copy_from_portfolios" v-model="allPortfoliosSelected"
                              @input="selectAllPortfolios()"
                              label="Select All" label-styling="font-medium">
                    </checkbox>
                </div>
            </div>

            <div class="ml-4 grid grid-cols-2 md:grid-cols-4 gap-x-2"
                 v-if="mutableSelection.copy_from_portfolios">
                <label v-for="portfolio in portfolios" class="flex gap-2 items-center cursor-pointer truncate">
                    <input type="checkbox" :value="portfolio.id" :key="portfolio.id"
                           v-model="mutableSelection.portfolio_ids" @input="portfolioSelected()"
                           class="focus:ring-indigo-600 h-4 w-4 text-indigo-600 rounded transition duration-300 cursor-pointer m-1">
                    {{ portfolio.name }}
                </label>
            </div>

            <div class="text-red-500" v-if="form.errors.has(mutableSelection.section + '.portfolio_ids')">
                {{ form.errors.get(mutableSelection.section + ".portfolio_ids") }}
            </div>

            <div class="flex flex-col gap-1" v-if="!mutableSelection.disabled">
                <div class="w-full flex flex-wrap">
                    <checkbox class="w-full md:w-1/3" v-model="mutableSelection.remember_portfolio_names" @input="rememberPortfolioNames()"
                              label="Remember portfolio names"
                              label-styling="font-medium"></checkbox>

                    <div class="w-full md:w-2/3 flex items-center justify-end gap-2" v-if="!mutableSelection.remember_portfolio_names">
                        <label class="font-medium">(Optional) Target portfolio name</label>
                        <text-input
                            placeholder="Portfolio Name (OPTIONAL)"
                            v-model="mutableSelection.target_portfolio_name">
                        </text-input>
                    </div>
                </div>

                <span class="text-gray-400 ml-0 md:ml-7">
                    If you don't remember portfolio names and don't specify a target name, the default portfolio will be used
                </span>
            </div>

            <div v-else>
                <span class="font-medium text-yellow-600 bg-yellow-100 p-1 rounded-md">
                    You can't remember portfolios names or choose a target portfolio name for {{ mutableSelection.section }} since you already chose these options elsewhere
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MigrateTeamPortfolioSelect",

    props: {
        selection: {
            type: Object,
            required: true
        },
        portfolios: {
            type: Array,
            required: true
        },
        form: {
            type: Object,
            required: true,
            description: "Used to easily get and display errors"
        },
    },

    data () {
        return {
            allPortfoliosSelected: false,
            mutableSelection: {},
        };
    },

    mounted () {
        this.mutableSelection = this.selection;
    },

    watch: {
        selection (newVal) {
            this.mutableSelection = newVal;
        },

        mutableSelection: {
            deep: true,
            handler (newVal) {
                this.updateSelection(newVal);
            }
        },
    },

    methods: {
        togglePortfolioList () {
            this.clearPortfolioIdErrors();

            if (!this.mutableSelection.copy_from_portfolios) {
                this.$set(this.mutableSelection, "portfolio_ids", []);
                this.updateAllIssuesSelected(false);
            }
        },

        selectAllPortfolios () {
            this.clearPortfolioIdErrors();

            if (this.mutableSelection.portfolio_ids.length !== this.portfolios.length) {
                this.$set(this.mutableSelection, "portfolio_ids", this.portfolios.map(portfolio => portfolio.id));
                _.uniq(this.mutableSelection.portfolio_ids);
            } else {
                this.$set(this.mutableSelection, "portfolio_ids", []);
            }
        },

        portfolioSelected () {
            this.clearPortfolioIdErrors();
            // if all portfolios are selected, set the allPortfolioSelected to true
            this.$nextTick(() => {
                this.updateAllIssuesSelected(this.mutableSelection.portfolio_ids.length === this.portfolios.length);
            });
        },

        updateAllIssuesSelected (value) {
            this.allPortfoliosSelected = value;
        },

        rememberPortfolioNames () {
            this.$nextTick(() => {
                if (this.mutableSelection.remember_portfolio_names) {
                    this.$set(this.mutableSelection, "target_portfolio_name", null);
                }
            });
        },

        selectSameAsAssetPortfolios () {
            this.$set(this.mutableSelection, "portfolio_ids", this.form.assets.portfolio_ids);
        },

        clearPortfolioIdErrors () {
            this.$emit("clear-form-portfolio-errors", this.mutableSelection.section);
        },

        updateSelection () {
            this.$emit("update-portfolio-selection", this.mutableSelection);
        },
    },
};
</script>